import { PostOperation } from '@/api/rest/base/operations';
import BaseApi from './base/BaseApi';

/**
 * Задания AI (ТЗ 4.1, 5.1): создание (ответ 202), чтение состояния и результата, применение
 * результата импорта и выбранного фото. Сгенерировано Claude.
 */
export default class SpecAiJobApi extends BaseApi {
  static entityName = 'spec_ai_jobs';

  /** Применить проверенный дизайнером результат импорта (ТЗ 4.1, 5.2). */
  applyImport(id, rows, withPreloader = false) {
    const operation = new PostOperation(`${this.getIri(id)}/apply_import`, { rows });
    return this.execute(operation, withPreloader);
  }

  /**
   * Применить проверенное поставщиком сопоставление КП (ТЗ 4.2, 5.5): строки «строка КП → позиция
   * запроса» с полями отклика; ответ — созданные черновики откликов.
   */
  applyMatch(id, rows, withPreloader = false) {
    const operation = new PostOperation(`${this.getIri(id)}/apply_match`, { rows });
    return this.execute(operation, withPreloader);
  }

  /** Отменить задание в очереди или в работе (ТЗ 4.1 «Отменить задание»); ответ — задание. */
  cancel(id, withPreloader = false) {
    const operation = new PostOperation(`${this.getIri(id)}/cancel`, {});
    return this.execute(operation, withPreloader);
  }

  /** Применить выбранное фото: { itemId, imageUrl }; ответ — позиция (ТЗ 4.1, 5.4). */
  applyPhoto(id, params, withPreloader = false) {
    const operation = new PostOperation(`${this.getIri(id)}/apply_photo`, params);
    return this.execute(operation, withPreloader);
  }
}
